import { extraContent } from "@/mocks/landingData";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function ExtraContent() {
  const { ref, visible } = useScrollReveal({ threshold: 0.05 });

  return (
    <section ref={ref} className="py-16 md:py-24 bg-background-100">
      <div className={`w-full max-w-4xl mx-auto px-4 md:px-8 lg:px-12 transition-all duration-600 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{ transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)" }}>
        <div className="prose prose-lg max-w-none">
          <div className="text-foreground-800 text-xl md:text-2xl leading-relaxed whitespace-pre-line">
            {extraContent}
          </div>
        </div>
      </div>
    </section>
  );
}